
import { computed, ComputedRef, defineComponent } from 'vue';
import authStore from '@/shared/auth/auth.store';

export default defineComponent({
    name: 'NetPrice',
    setup() {
        const showNetPrice: ComputedRef<boolean> = computed(() => {
            return authStore.showNetPrice;
        });
        return {
            showNetPrice,
        };
    },
});
